import { useSelector } from 'react-redux'
import useGetExchangeRates from '../../common/category/useGetExchangeRates'
import { Element } from '../../common/html/element'
import { ScrollComponent } from '../../common/scrollComponent'
import { formatCurrency } from '../../helpers/value'
import { CURRENCY } from '../../utils/currency'
import { REPORT_TYPE } from '../constant'
import classes from '../index.module.scss'
import {
  selectBusinessCreditReportId,
  selectCheckIds,
  selectFactSheetId,
  selectTotalPrice,
} from '../store/slice'
import ItemBusinessCreditReport from './components/business/ItemBusinessCreditReport'
import ItemFactSheet from './components/factSheet/ItemFactSheet'

export const HEIGHT_HEADER = 32

const ContentOrder = ({ height }) => {
  const { exchangeRates } = useGetExchangeRates()

  const idCheck = useSelector(selectCheckIds)
  const factSheetId = useSelector(selectFactSheetId)
  const businessCreditReportId = useSelector(selectBusinessCreditReportId)
  const discountedPriceFactsheet = useSelector(
    selectTotalPrice('discountedPriceFactSheet'),
  )
  const discountedPriceBusiness = useSelector(
    selectTotalPrice('discountedPriceBusiness'),
  )
  const locale = useSelector((state) => state.i18n.locale)

  const factSheetIdCheck = factSheetId.filter((item) => idCheck.includes(item))
  const businessCreditReportIdCheck = businessCreditReportId.filter((item) =>
    idCheck.includes(item),
  )

  return (
    <>
      {!!height && (
        <>
          {!!factSheetIdCheck.length && (
            <Element className="mt1" style={{ border: '1px solid #D5D5D5' }}>
              <Element
                className={`${classes.header} dFlex justifyContentBetween`}
                style={{ backgroundColor: '#F3F3F3', height: HEIGHT_HEADER }}
              >
                <Element style={{ fontSize: 14 }} className="fw600">
                  {REPORT_TYPE.FIINGATE_FACTSHEET}
                </Element>
                <Element style={{ fontSize: 14 }} className="fw600">
                  {formatCurrency(
                    discountedPriceFactsheet,
                    CURRENCY.USD,
                    CURRENCY.VND,
                    exchangeRates,
                    locale,
                  )}
                </Element>
              </Element>
              <ScrollComponent
                autoHeight
                autoHeightMax={
                  !businessCreditReportIdCheck.length
                    ? height - HEIGHT_HEADER
                    : 500
                }
              >
                {factSheetIdCheck.map((id, index) => (
                  <ItemFactSheet key={id} id={id} index={index} />
                ))}
              </ScrollComponent>
            </Element>
          )}
          {!!businessCreditReportIdCheck.length && (
            <Element className="mt1" style={{ border: '1px solid #D5D5D5' }}>
              <Element
                className={`${classes.header} dFlex justifyContentBetween`}
                style={{ backgroundColor: '#F3F3F3', height: HEIGHT_HEADER }}
              >
                <Element style={{ fontSize: 14 }} className="fw600">
                  {REPORT_TYPE.BUSINESS_CREDIT}
                </Element>
                <Element style={{ fontSize: 14 }} className="fw600">
                  {formatCurrency(
                    discountedPriceBusiness,
                    CURRENCY.USD,
                    CURRENCY.VND,
                    exchangeRates,
                    locale,
                  )}
                </Element>
              </Element>
              <ScrollComponent
                autoHeight
                autoHeightMax={
                  !factSheetIdCheck.length ? height - HEIGHT_HEADER : 500
                }
              >
                {businessCreditReportIdCheck.map((id, index) => (
                  <ItemBusinessCreditReport key={id} id={id} index={index} />
                ))}
              </ScrollComponent>
            </Element>
          )}
        </>
      )}
    </>
  )
}

export default ContentOrder
